module.exports = __webpack_public_path__ + "img/img5_3.fb5eeb76.jpeg";